import { TextCapitalized } from "@/components";
import { useStore } from "@/store";
import classNames from "classnames";
import format from "date-fns/format";
import { ru } from "date-fns/locale";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";
import styles from "./Analytics.module.scss";
import { Rates, Summaries } from "./_dependencies";

export const Analytics: FunctionComponent = observer((): ReactElement => {
  const store = useStore();

  return (
    <div
      className={classNames(["analytics contentBox", styles.containerDefault])}
    >
      <div className="contentBoxHeader">
        <h2 className="white">
          <TextCapitalized>
            {format(store.dashboard.date, "LLLL", { locale: ru })}
          </TextCapitalized>
        </h2>
        <Rates />
      </div>
      <Summaries
        currency={store.dashboard.baseCurrency || store.app.currency}
        loading={store.dashboard.loading}
        {...store.dashboard.summary}
        onPress={store.dashboard.toggleCurrency}
      />
    </div>
  );
});
